import React from 'react';
import { Link } from 'react-router-dom';
import { navItems, brand, booking } from '../mock';
import { useBooking } from '../context/BookingContext';
import { Mail, MapPin, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const { openBooking } = useBooking();
  return (
    <footer className="bg-[#241033] text-[#E7E2EE] pt-20 pb-10">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-12 pb-14">
          <div className="md:col-span-5">
            <div className="bg-white rounded-md px-3 py-2 inline-block mb-6 shadow-[0_4px_20px_-8px_rgba(0,0,0,0.4)]">
              <img src={brand.logoCombo} alt="The Answer Group Consulting" className="h-16 w-auto object-contain" />
            </div>
            <p className="font-light text-[#B9A9CC] max-w-md leading-relaxed">
              {brand.tagline}
            </p>
            <p className="mt-6 text-sm font-light text-[#9A8AAF] italic">
              “You are the answer to the very problem you were designed to solve.”
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-[#7E5C9E] mb-5">Explore</div>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-[#D9CEE6] hover:text-white transition-colors text-sm font-light">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-[#7E5C9E] mb-5">Connect</div>
            <a href={`mailto:${brand.email}`} className="flex items-center gap-3 text-[#D9CEE6] hover:text-white transition-colors text-sm font-light mb-3">
              <Mail className="w-4 h-4" strokeWidth={1.5} /> {brand.email}
            </a>
            <div className="flex items-center gap-3 text-[#D9CEE6] text-sm font-light mb-6">
              <MapPin className="w-4 h-4" strokeWidth={1.5} /> {brand.location}
            </div>
            <button
              onClick={() => openBooking(booking.alignmentLab, 'Book a Session')}
              className="group inline-flex items-center gap-2 border border-[#5B3A7A] rounded-full px-6 py-3 text-sm tracking-luxe uppercase text-white hover:bg-[#43265E] transition-all"
            >
              Book a Session
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div className="hairline opacity-40" />
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#8A7A9F] font-light tracking-wide">
            © {new Date().getFullYear()} The Answer Group Consulting, LLC. All rights reserved.
          </p>
          <p className="text-xs text-[#8A7A9F] font-light tracking-luxe uppercase">
            Led by {brand.founder}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
